// Dependency
import React, { useEffect, useState } from 'react';
import { Link } from "gatsby";
import axios from 'axios';

// Internationalization
import { useTranslation } from 'react-i18next';

// Components

// Context
import { useCart } from "../../contexts/cart-context";

// Services
import UtilsService from "../../services/utils.service";
import GA from "../../services/ga.service";

// Styles
import * as styles from './mini-cart.module.scss';

// Assets
import cartIcon from './assets/quick-cart.svg'
import cartStar from './assets/quick-star.svg'
import CartItem from "./cart-item/cart-item";
import iconClose from "./assets/icon-close.svg";

// Template
const QuickCart = (props) => {

    const { cart, quickCartOpen, toggleQuickCart, lastAddedItem } = useCart();

    const [miniCart, setMiniCart] = useState(false);

    useEffect(() => {
        setMiniCart(cart);
        //Todo check if country change and delay ajax until right lang is set
        if (cart.token && cart.selection.items.length > 0) {
            const cartIds = [];
            cart.selection.items.map((item) => {
                cartIds.push(item.product.product)
            })
            axios.defaults.headers['post']['Accept'] = `*/*;api-token: ${cart.token}`
            axios({
                method: 'post',
                url: `${process.env.CENTRA_URL_PRODUCTS}`,
                data: { products: cartIds, relatedProducts: true }
            }).then(response => {

                let products = [];
                response.data.products.map((product) => {
                    product.relatedProducts.map((relProd) => {
                        if (!cartIds.includes(relProd.product)) products.push(relProd);
                    })
                })
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [cart])

    useEffect(() => {
        setMiniCart(cart);
    }, [cart])

    // Translation Function
    const { t } = useTranslation();

    const addedItem = cart && cart.selection ? cart.selection.items.find(item => item.line === lastAddedItem) : false;

    return (
        <div className={`${styles.miniCart} ${styles.cdQuickCartWrapper} ${quickCartOpen ? styles.isOpen : ''}`}>
            <button className={`${styles.miniCart__overlay} ${styles.cdQuickCartOverlay}`} onClick={() => { toggleQuickCart() }}>
                <div className={`${styles.miniCart__close}`} >
                    {t('miniCart.continueShopping')}
                </div>
            </button>
            <div className={`${styles.miniCart__content} ${styles.cdQuickCartContent}`}>
                <div className={styles.progress}>
                    {quickCartOpen ? <div className={styles.progressValue}></div>
                        : ''}

                </div>
                <div className={styles.cdQuickCart}>
                    {addedItem &&
                        <div className={styles.cdQuickCartTop}>
                            <div className={styles.cdQuickCartTopLeft}>
                                <div className={`${styles.cdQuickCartImg} cd-background-img`}>
                                    <img src={addedItem.product.media.standard[0]} alt={addedItem.product.name} />
                                </div>
                                <div className={styles.cdQuickCartTopText}>
                                    <div className={styles.cdQuickCartTopAtcText}>
                                        <span>{t('miniCart.quickAdd')}</span>
                                    </div>
                                    <h3>{addedItem.product.name}</h3>
                                </div>
                            </div>
                            <div className={styles.cdQuickCartIcon}>
                                <div className={styles.cdQuickCartCount}>
                                    <span>{miniCart && miniCart.selection.totals.totalQuantity ? miniCart.selection.totals.totalQuantity : 0}</span>
                                </div>
                            </div>
                        </div>
                    }

                    <div className={styles.cdQuickCartBottom}>
                        <Link to={`/${UtilsService.getLocaleFromUrl().country}/checkout/`}>
                            <button className={`${styles.cdQuickCartButton} button`} onClick={() => GA.onCheckout(cart.selection.items, cart.selection.discounts.vouchers)}>
                                {t('miniCart.continue')}
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default QuickCart;